import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'gatsby';

import styles from './postTags.module.scss';

class PostTags extends Component {
  render() {
    const { tags } = this.props;
    return (
      <>
        {tags
          && tags.map((tag) => {
            return (
              <Link
                key={tag}
                className={styles.postTag}
                to={`/tags/${_.kebabCase(tag)}`}
              >
                {tag}
              </Link>
            );
          })}
      </>
    );
  }
}

export default PostTags;
